type Props = {
  title: string
}

/**
 * The heading above a single entry in a comparison popover. It is shared so
 * that entries laid out side by side and entries rendered as a diff keep the
 * same heading.
 */
export const DiffEntryTitle = ({ title }: Props) => (
  <div className="mb-2 text-center font-medium">{title}</div>
)
